// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"180":"14d48726","191":"641c3b99","192":"e296bf6f","215":"ad9f543c","488":"6b9b3cea","595":"ccd61782","749":"c6ac0952","768":"e1cc58b9","865":"fcc93d9c","951":"08b65572"}[chunkId] + ".chunk.js";
};